import React from 'react';
import ColorLinesOptionFilters from './ColorLinesOptionFilters';
import ExteriorOptionFilters from './ExteriorOptionFilters';
import InteriorOptionFilters from './InteriorOptionFilters';
import RoofAndMirrorCapsOptionFilters from './RoofAndMirrorCapsOptionFilters';
import TrimOptionFilters from './TrimOptionFilters';
import WheelOptionFilters from './WheelOptionFilters';
import FilterSection from './FilterSection';
import enhance from './enhance';
import styles from './styles.module.scss';
import GenClose from './close.svg';
import searchFilterIcon from './search_filter_icon.svg';

const DesignOptionFilters = ({
  isMini,
  exteriorFiltersHeader,
  interiorFiltersHeader,
  trimFiltersHeader,
  wheelFiltersHeader,
  roofAndMirrorCapsFiltersHeader,
  colorLinesFiltersHeader,
  linkSearchWithinGroup,
  linkFiltersWithinGroup,
  setActiveFilters,
  paintOption,
  interiorOption,
  trimOption,
  wheelOption,
  colorLineOption,
  roofAndMirrorCapOption,
  clearFilter,
  clearAllFilters,
  clearFiltersText,
  toggleFilters,
  isOpen,
  availableOptions,
}) => {
  return (
    <div>
      <div className={styles.clearFiltersContainer}>
        <span
          className={styles.searchFilter}
          onClick={toggleFilters}
          data-search="search"
        >
          {isOpen ? (
            <div className={styles.searchContainer}>
              <img
                src={GenClose}
                alt="tooltip"
                className={styles.imageIconFormatClose}
              />
              {linkFiltersWithinGroup}
            </div>
          ) : (
            <div className={styles.searchContainer}>
              <img
                src={searchFilterIcon}
                alt="tooltip"
                className={styles.imageIconFormat}
              />
              {linkSearchWithinGroup}
            </div>
          )}
        </span>
        {isOpen ? (
          <span className={styles.clearFiltersBtn} onClick={clearAllFilters}>
            {clearFiltersText}
          </span>
        ) : null}
      </div>
      {isOpen ? (
        <div>
          <FilterSection headerText={exteriorFiltersHeader}>
            <ExteriorOptionFilters
              setActiveFilters={setActiveFilters}
              activeFilters={paintOption}
              clearFilter={clearFilter}
              availableOptions={availableOptions.paintOption}
            />
          </FilterSection>
          <FilterSection headerText={interiorFiltersHeader}>
            <InteriorOptionFilters
              setActiveFilters={setActiveFilters}
              activeFilters={interiorOption}
              clearFilter={clearFilter}
              availableOptions={availableOptions.interiorOption}
            />
          </FilterSection>
          <FilterSection headerText={trimFiltersHeader}>
            <TrimOptionFilters
              setActiveFilters={setActiveFilters}
              activeFilters={trimOption}
              clearFilter={clearFilter}
              availableOptions={availableOptions.trimOption}
            />
          </FilterSection>
          <FilterSection headerText={wheelFiltersHeader}>
            <WheelOptionFilters
              setActiveFilters={setActiveFilters}
              activeFilters={wheelOption}
              clearFilter={clearFilter}
              availableOptions={availableOptions.wheelOption}
            />
          </FilterSection>
          {isMini && (
            <div>
              <FilterSection headerText={colorLinesFiltersHeader}>
                <ColorLinesOptionFilters
                  setActiveFilters={setActiveFilters}
                  activeFilters={colorLineOption}
                  clearFilter={clearFilter}
                  availableOptions={availableOptions.colorLineOption}
                />
              </FilterSection>
              <FilterSection headerText={roofAndMirrorCapsFiltersHeader}>
                <RoofAndMirrorCapsOptionFilters
                  setActiveFilters={setActiveFilters}
                  activeFilters={roofAndMirrorCapOption}
                  clearFilter={clearFilter}
                  availableOptions={availableOptions.roofAndMirrorCapOption}
                />
              </FilterSection>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default enhance(DesignOptionFilters);
